import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { defer, observable, Observable, of, throwError } from 'rxjs';
import { map, catchError, switchMap, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { AppAuthService } from '../auth/app-auth.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  @BlockUI() blockUI!: NgBlockUI;

  constructor(private router: Router,
              private auth: AppAuthService,
              private toastr: ToastrService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.blockUI.start();

    // トークン付与
    const grantToken = (token: string): Observable<HttpEvent<any>> => {
      // トークンが取れなかった
      if (!token) {
        // this.auth.login();
        return of(null)
      }

      // JWT付与
      const headers = req.headers.set("Authorization", `Bearer ${token}`);
      const requestClone = req.clone({headers});
      return next.handle(requestClone).pipe(
        // responseが返ってきた後の処理
        finalize(() => {
            this.blockUI.stop();
        }),
        catchError(error=> this.handleError(error)));
    };

    return this.auth.getToken()
      .pipe(
        catchError(result => {
          console.log(Date.now(), 'intercept token error', result);
          this.toastr.error('トークン取得に失敗', 'ポップアップブロックなど見直してください。');
          return of(null);
        }),
        switchMap((token: string) => grantToken(token))
    );
  }

  /**
   * HTTP エラーハンドリング
   * @param error
   * @returns
   */
  private handleError(error: HttpErrorResponse) {
    // Grobal Error Handle
    // 404の場合の処理
    if (error.status === 404) {
      this.blockUI.stop();
      this.router.navigate(['']);
    }
    // 401の場合の処理
    if (error.status === 401) {
        // ログアウト
        this.auth.logout();
        this.blockUI.stop();
    }
    // 412の場合の処理
    if (error.status === 412) {
      this.blockUI.stop();
      this.router.navigate(['maintenance']);
  }

    // 500系エラーの場合の処理
    if (error.status >= 500) {
        this.toastr.error(error.message, '通信エラー発生');
        this.router.navigate(['error']);
    }
    
    return throwError(error);
  }
}
